// Copyright (c) 2016 Deere & Company

import actions from '../../../../sharedmodules/actions-list';

export const resetNewTransfer = () => ({
    type: actions.RESET_NEW_TRANSFER,
});
